import { render, staticRenderFns } from "./postion.vue?vue&type=template&id=dc14aef6"
import script from "./postion.vue?vue&type=script&lang=js"
export * from "./postion.vue?vue&type=script&lang=js"
import style0 from "./postion.vue?vue&type=style&index=0&id=dc14aef6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports